var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoinInner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "url(#paint0_linear_7203_92906)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99933 11.8252C9.1039 11.8252 9.99933 10.112 9.99933 7.99854C9.99933 5.88513 9.1039 4.17188 7.99933 4.17188C6.89476 4.17188 5.99933 5.88513 5.99933 7.99854C5.99933 10.112 6.89476 11.8252 7.99933 11.8252Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02534 11.2493C5.80534 11.3026 5.57201 11.3359 5.33201 11.3359C3.49201 11.3359 1.99868 9.8426 1.99868 8.0026C1.99868 6.1626 3.49201 4.66927 5.33201 4.66927C5.57201 4.66927 5.80534 4.7026 6.02534 4.75594C6.28534 4.3826 6.61201 4.00927 7.01868 3.66927C6.49868 3.4626 5.93201 3.33594 5.33201 3.33594C2.75868 3.33594 0.665344 5.42927 0.665344 8.0026C0.665344 10.5759 2.75868 12.6693 5.33201 12.6693C5.93201 12.6693 6.49868 12.5426 7.01868 12.3359C6.61201 11.9959 6.28534 11.6226 6.02534 11.2493ZM10.6653 3.33594C10.0653 3.33594 9.49868 3.4626 8.97868 3.66927C9.38534 4.00927 9.71201 4.3826 9.97201 4.75594C10.192 4.7026 10.4253 4.66927 10.6653 4.66927C12.5053 4.66927 13.9987 6.1626 13.9987 8.0026C13.9987 9.8426 12.5053 11.3359 10.6653 11.3359C10.4253 11.3359 10.192 11.3026 9.97201 11.2493C9.71201 11.6226 9.38534 11.9959 8.97868 12.3359C9.49868 12.5426 10.0653 12.6693 10.6653 12.6693C13.2387 12.6693 15.332 10.5759 15.332 8.0026C15.332 5.42927 13.2387 3.33594 10.6653 3.33594Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7203_92906",
    x1: 7.99933,
    y1: 4.17187,
    x2: 7.99933,
    y2: 11.8252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7203_92906",
    x1: 7.99868,
    y1: 3.33594,
    x2: 7.99868,
    y2: 12.6693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6E7C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D6E7C4D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinInner);
export default __webpack_public_path__ + "static/media/join_inner.c329bc8014ee340e1b56c87d9cfa824f.svg";
export { ForwardRef as ReactComponent };